import React from "react";
import { Table, TableBody, TableRow, TableRowColumn } from "material-ui";
import { tdStyle } from "../../components/Questionnaire/QuestionnaireTable";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import EditorInsertDriveFile from "material-ui/svg-icons/editor/insert-drive-file";
import ActionGetApp from "material-ui/svg-icons/action/get-app";
import { CSVLink } from "react-csv";
import { convertToCsv } from "./convertToCsv";
import { checkMobile, isIpadOS } from "../../lib";

export default class TranscriptionTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      csvData: [],
      csvFileName: "",
    };
  }

  downloadTranscription = (recording) => {
    if (recording) {
      const googleTranscription = JSON.parse(recording.google_stt);
      if (googleTranscription.length > 0) {
        const csvData = convertToCsv(recording, googleTranscription);
        const date = moment.unix(recording.recording_started_at);
        const csvFileName = `${
          recording.channel_id.split(".")[1]
        }_${date.format("YYYYMMDDHHmm")}`;
        this.setState({ csvData, csvFileName }, () => {
          if (this.csvLinkRef && this.csvLinkRef.link) {
            this.csvLinkRef.link.click();

            setTimeout(() => {
              this.setState({ csvData: [], csvFileName: "" });
            }, 3000);
          }
        });
      }
    }
  };

  render() {
    return (
      <div
        style={{ textAlign: "center", overflow: "hidden auto", height: "72vh" }}
      >
        <CSVLink
          ref={(r) => (this.csvLinkRef = r)}
          data={this.state.csvData}
          filename={this.state.csvFileName}
        ></CSVLink>
        <h4 style={{ textAlign: 'left' }}>{<FormattedMessage id="transcriptions.searchResult" />}</h4>
        <Table
          selectable={false}
          selectedColor="black"
          bodyStyle={{
            display: "contents",
          }}
          style={{ border: "1px solid #b8b8b8", minWidth: "612px" }}
        >
          <TableBody deselectOnClickaway={false} displayRowCheckbox={false}>
            <TableRow
              style={{
                border: "1px solid #b8b8b8",
                backgroundColor: "#6B7c93",
                color: "#fff",
              }}
            >
              <TableRowColumn colSpan={3} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="roomRecordings.room_name" />}
              </TableRowColumn>

              <TableRowColumn colSpan={4} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="transcriptions.date" />}
              </TableRowColumn>

              <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="roomRecordings.transcription" />}
              </TableRowColumn>

              {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={{ ...tdStyle, color: "#fff" }}>
                {<FormattedMessage id="roomRecordings.transcriptionDownload" />}
              </TableRowColumn>}
            </TableRow>

            {!this.props.isFetchingList &&
              (this.props.transcriptions.length === 0 && (
                <TableRow
                  selected={false}
                  className="light-row"
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={!checkMobile() && !isIpadOS() ? 11 : 9} style={tdStyle}>
                    <FormattedMessage id="transcriptions.noTranscriptionsFound" />
                  </TableRowColumn>
                </TableRow>
              ))}

            {this.props.transcriptions.map((transcription, index) => {
              return (
                <TableRow
                  key={index}
                  selected={false}
                  className={index % 2 == 0 ? "dark-row" : "light-row"}
                  style={{
                    backgroundColor: "#f2f3f6",
                    borderBottom: "1px solid #b8b8b8",
                  }}
                >
                  <TableRowColumn colSpan={3} style={tdStyle}>
                    {transcription.channel_id.split(".")[1]} <br />(
                    {transcription.is_webinar ? (
                      <FormattedMessage id="activityLogs.webinar" />
                    ) : (
                      <FormattedMessage id="activityLogs.conference" />
                    )}
                    )
                  </TableRowColumn>

                  <TableRowColumn colSpan={4} style={tdStyle}>
                    {moment
                      .unix(transcription.recording_ended_at)
                      .format("YYYY-MM-DD HH:mm:ss")}
                  </TableRowColumn>

                  <TableRowColumn colSpan={2} style={tdStyle}>
                    <EditorInsertDriveFile
                      onClick={() =>
                        this.props.transcriptionInfo(transcription)
                      }
                      style={{
                        width: "25px",
                        height: "25px",
                        color: "#6b7c93",
                        cursor: "pointer",
                      }}
                    />
                  </TableRowColumn>

                  {!checkMobile() && !isIpadOS() && <TableRowColumn colSpan={2} style={tdStyle}>
                    <ActionGetApp
                      onClick={() => this.downloadTranscription(transcription)}
                      style={{
                        width: "25px",
                        height: "25px",
                        color: "#6b7c93",
                        cursor: "pointer",
                      }}
                    />
                  </TableRowColumn>}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/routes/Transcriptions/TranscriptionTable.js